import { defineStore } from 'pinia'
import { ref } from 'vue'
import storeConfigs from 'constants/storeConfigs.ts'

export const useLocaleStore = defineStore(
	storeConfigs.locale.name,
	() => {
		const supportedLocales = ['en', 'de']
		const fallbackLocale = 'de'
		const locale = ref()

		function initialise() {
			const rawLocale = locale.value ?? fallbackLocale
			locale.value = supportedLocales.includes(rawLocale)
				? rawLocale
				: fallbackLocale
		}

		return { locale, initialise }
	},
	{
		persist: storeConfigs.locale.persist,
	}
)
